module.exports = __webpack_public_path__ + "static/media/adeola-logo-mobile.f7b140f2.svg";